import { render, staticRenderFns } from "./ProductParamForm.vue?vue&type=template&id=6d9216e6&scoped=true"
import script from "./ProductParamForm.vue?vue&type=script&lang=js"
export * from "./ProductParamForm.vue?vue&type=script&lang=js"
import style0 from "./ProductParamForm.vue?vue&type=style&index=0&id=6d9216e6&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d9216e6",
  null
  
)

export default component.exports